import { render, staticRenderFns } from "./portal-card.vue?vue&type=template&id=20893195&"
import script from "./portal-card.vue?vue&type=script&lang=ts&"
export * from "./portal-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports